import { call, put } from 'redux-saga/effects';
import CampaignActions from '../redux/CampaignRedux';
import MessagesActions from '../redux/MessagesRedux';

export function* getCampaign(api, action) {
  const response = yield call(api.getCampaignDetail, action.id);

  if (response.ok) {
    yield put(CampaignActions.campaignSuccess(response.data));
  } else {
    yield put(CampaignActions.campaignFailure(response.data?.title || response.problem));
    yield put(MessagesActions.messagesShow({
      type: 'error',
      code: response.status,
      title: response.data?.title || response.problem
    }));
  }
}

export function* createCampaign(api, action) {
  const response = yield call(api.addCampaign, action.campaign);

  if (response.ok) {
    yield put(CampaignActions.campaignSuccess(response.data));
    yield put(MessagesActions.messagesShow({
      type: 'success',
      code: 'campaignCreate',
      title: 'Кампания успешно создана'
    }));
  } else {
    yield put(CampaignActions.campaignFailure(response.data?.title || response.problem));
    yield put(MessagesActions.messagesShow({
      type: 'error',
      code: response.status,
      title: "Кампания не создана",
      text:  response.data?.title || response.problem
    }));
  }
}

export function* updateCampaign(api, action) {
  const response = yield call(api.editCampaign, action.campaign);

  if (response.ok) {
    yield put(CampaignActions.updateCampaignSuccess(response.data));
    yield put(MessagesActions.messagesShow({
      type: 'success',
      code: 'campaignUpdate',
      title: 'Кампания успешно обновлена'
    }));
  } else {
    yield put(CampaignActions.campaignFailure(response.data?.title || response.problem));
    yield put(MessagesActions.messagesShow({
      type: 'error',
      code: response.status,
      title: "Кампания не обновлена",
      text:  response.data?.title || response.problem
    }));
  }
}

export function* uploadVinFile(api, action) {
  const { id, file } = action;
  const response = yield call(api.uploadVinListFile, id, file);

  if (response.ok) {
    yield put(CampaignActions.uploadVinFileSuccess(response.data));
    yield put(
      MessagesActions.messagesShow({
        type: 'success',
        code: 'vinUpload',
        title: 'Файл VIN успешно загружен',
      })
    );
  } else {
    yield put(
      CampaignActions.uploadVinFileFailure(response.data?.title || response.problem)
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data?.title || response.problem,
      })
    );
  }
}

export function* uploadParsedVins(api, action) {
  const { id, parsedVins } = action;
  const response = yield call(api.uploadVinList, id, parsedVins);

  if (response.ok) {
    yield put(CampaignActions.uploadParsedVinsSuccess(response.data));
    yield put(
      MessagesActions.messagesShow({
        type: 'success',
        code: 'vinUpload',
        title: 'VIN успешно обработаны',
      })
    );
  } else {
    yield put(
      CampaignActions.uploadParsedVinsFailure(response.data?.title || response.problem)
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data?.title || response.problem,
      })
    );
  }
}

export function* uploadCarsFilter(api, action) {
  const { id, rules } = action;
  const response = yield call(api.uploadCarsFilter, id, rules);

  if (response.ok) {
    yield put(CampaignActions.uploadCarsFilterSuccess(response.data));
    yield put(
      MessagesActions.messagesShow({
        type: 'success',
        code: 'filterApplied',
        title: 'Фильтр успешно применен',
      })
    );
  } else {
    yield put(
      CampaignActions.uploadCarsFilterFailure(response.data?.title || response.problem)
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data?.title || response.problem,
      })
    );
  }
}

export function* deleteCampaign(api, action) {
  const response = yield call(api.deleteCampaign, action.id);

  if (response.ok) {
    yield put(CampaignActions.deleteCampaignSuccess(response.data));
    yield put(MessagesActions.messagesShow({
      type: 'success',
      code: 'campaignDelete',
      title: 'Кампания успешно удалена'
    }));
  } else {
    yield put(CampaignActions.campaignFailure(response.data?.title || response.problem));
    yield put(MessagesActions.messagesShow({
      type: 'error',
      code: response.status,
      title: response.data?.title || response.problem
    }));
  }
}
